import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/site/components/builder/HeadingBlock/HeadingBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/site/components/design/Section/Section.tsx");
;
import(/* webpackMode: "eager" */ "/srv/site/styles/pages/sitemap.module.scss");
